import {defineStore} from 'pinia'
import {FilterMatchMode} from "primevue/api";
import _ from "lodash";
import {useAssetsStore} from "@/stores/assets.js";
import {getFirstPage, onFilter, onPage, onRowsUpdate, onSearch, onSort} from "@/stores/_helpers.js";

export const useAssetsIndexPageStore = defineStore('assetsIndexPage', {
    state: () => ({
        data: undefined,
        filters: null,
        totalRecords: 0,
        loading: true,
        params: {
            per_page: 20,
            page: 1,
            include: [
                'assetType',
                'devices.deviceModel',
                'devicesNeedingUpdate',
                'company',
                'rxSwins',
                'rxSwins.regulation',
            ],
            filter: {
                search: null
            }
        },
        pages: [
            10,
            20,
            50,
            100,
        ]
    }),
    getters: {
        getAssets: (state) => {
            return state.data?.data;
        },
        getFirstPage: (state) => {
            return getFirstPage(state.params)
        }
    },
    actions: {
        initFilters() {
            this.filters = {
                company_ids: {value: null, matchMode: FilterMatchMode.IN},
                asset_type_ids: {value: null, matchMode: FilterMatchMode.IN},
            }
        },
        onPage($event) {
            onPage($event, this.params);
            this.loadData();
        },
        onSort($event) {
            onSort($event, this.params);
            this.loadData();
        },
        onRowsUpdate(rowCount) {
            onRowsUpdate(rowCount, this.params);
        },
        onFilter($event) {
            onFilter($event, this.params);
            this.loadData();
        },
        onSearch: _.debounce(function () {
                onSearch(this.params)
                this.loadData();
            },
            500
        ),
        async loadData() {
            const assetsStore = useAssetsStore();
            this.loading = true;
            this.data = await assetsStore.indexAssets(this.params)
            this.totalRecords = this.data.total;
            this.loading = false;
        }
    },
});
